<template>
<div class="alert alert-warning p-1 mt-2 mb-1" v-if="show">
    {{'revisions.old_value' | trans}} {{text}}
</div>
</template>

<script>

export default {
    props: {
        value: {
            type: null,
            required: true
        },
        oldValue: {
            type: null,
            required: true
        },
        oldValuePretty: {
            type: null,
            required: false
        },
    },
    computed: {
        show: function(){
            return typeof this.oldValue !== "undefined" && this.oldValue !== this.value;
        },
        text: function(){
            return this.oldValuePretty ? this.oldValuePretty : this.oldValue;
        }
    }
}
</script>